<template>
   <section class="news">
      <div class="container">
         <div class="row">
            <div class="title pt-md-3 pt-0 mb-3">
               <label>{{ $res("site.news.label") }}</label>
               <span>{{ $res("site.news.label") }}</span>
            </div>
            <div
               class="col-12 col-md-4 d-md-block d-none"
               v-for="(item, index) in data"
               :key="index"
            >
               <div class="item">
                  <div
                     class="img"
                     :style="{
              'background-image': `url(${rootImagePath + item.imagePath})`,
            }"
                  ></div>
                  <div class="p-2">
                     <h6 class="pt-5">{{ item.name }}</h6>
                     <p class="pt-1 ps-0 pe-0">{{ item.caption }}</p>
                     <router-link :to="`/page/${item.slug}`">ادامه خبر</router-link>
                  </div>
               </div>
            </div>
         </div>
         <div class=" d-md-none d-block">
            
            <swiper :slidesPerView="'auto'" :spaceBetween="10" class="mySwiper">
               <swiper-slide v-for="(item, index) in data" :key="index" class="item">
                  <div
                     class="img"
                     :style="{
              'background-image': `url(${rootImagePath + item.imagePath})`,
            }"
                  ></div>
                  <div class="p-2">
                     <h6 class="pt-5">{{ item.name }}</h6>
                     <p class="pt-1 ps-0 pe-0">{{ item.caption }}</p>
                     <router-link :to="`/page/${item.slug}`">ادامه خبر</router-link>
                  </div>
               </swiper-slide>
            </swiper>
         </div>
         <div class="row">
            <div class="col-12">
               <router-link to="/page/Allnews" class="btn-question mt-md-5 mt-2 mb-3">ادامه اخبار</router-link>
            </div>
         </div>
      </div>
   </section>
</template>
<script>
import "swiper/swiper-bundle.css";
import { Swiper, SwiperSlide } from "swiper/vue/swiper-vue";
import { Mousewheel, Pagination } from "swiper";
export default {
   props: {
      data: {
         type: Object,
      },
      rootImagePath: {
         type: String,
      },
   },
   components: {
      swiper: Swiper,
      "swiper-slide": SwiperSlide,
   },
   setup() {
      return {
         modules: [Mousewheel, Pagination],
      };
   },
};
</script>


<style scoped>
.news {
   width: 100%;
   min-height: 300px;
   background-color: white;
   padding-bottom: 10px;
}

.item {
   width: 100%;
   height: 480px;
   overflow: hidden;
   border: 1px solid #f4f4f4;
   border-radius: 10px;
   background-color: #fff;
   margin-bottom: 10px;
   overflow: hidden;
   transition: all 0.5s;
   padding: 15px;
}

.item:hover {
   border: 1px solid #ebc75d;
   transform: scale(1.01);
}

.item .img {
   width: 100%;
   height: 250px;
   background-position: center center;
   background-size: cover;
   transition: all 1s;
   border-radius: 10px;

}
.news .title {
   float: left;
   width: 100%;
   position: relative;
}

.news .title,
.news .title label,
.news .title span {
   text-align: center;
   width: 100%;
   height: 70px;
}

.news .title label {
   font-size: 30px;
   margin: 0;
   color: #ebc75d;
   z-index: 1;
   position: relative;
}

.news .title span {
   font-size: 50px;
   opacity: 0.5;
   color: #f1f1f1;
   margin-top: -80px;
   z-index: 0;
   display: block;
}

.item h6 {
   text-align: center;
}

.item p {
   text-align: justify;
   color: rgb(139, 133, 133);
   padding: 10px;
}
.btn-question {
   background-color: #ebc75d;
   border: 1px solid #ebc75d;
   color: white;
   width: 150px;
   height: 50px;
   transition: all 0.5s;
   float: left;
   text-align: center;
   text-decoration: none;
   position: relative;
   padding-top: 15px;
}

.btn-question::before,
.btn-question::after {
   content: "";
   position: absolute;
   background: #ebc75d;
   transition: all 0.5s;
}

.btn-question::before {
   top: 10px;
   left: -5px;
   width: 1px;
   height: 100%;
}

.btn-question::after {
   bottom: -5px;
   right: 10px;
   width: 100%;
   height: 1px;
}

.btn-question:hover::before {
   height: 0;
}

.btn-question:hover::after {
   width: 0;
}

.btn-question:hover {
   background-color: white;
   color: black;
   border: 1px solid #ebc75d;
}

.mySwiper .item,
.mySwiper .item .img {
   max-width: 380px;
}
/* //////////////////////////////// */

/* ///////////////////////////// */
@media screen and (max-width: 576px) {
   .title {
      margin-top: 50px;
   }
   .item:hover {
      border: unset;
      transform: unset;
   }
}
</style>